class Video {

  constructor(content) {
    this.id = content.id;
    this.description = content.description;
    
    switch (content.type) {
      case 'youtube':
        this.type = 'youtube'
        this.url = 'https://www.youtube.com/watch?v=' + this.id
        this.embed_url = 'https://www.youtube.com/embed/' + this.id
        this.thumb = 'https://img.youtube.com/vi/' + this.id + '/default.jpg'
        break;
      case 'vimeo':
        this.type = 'vimeo'
        this.url = 'https://www.vimeo.com/' + this.id
        this.thumb = '';
        break;
      default:
        throw 'Unknown video type.'
        break;
    }
  }

  getUrl() {
    return this.url;
  }

}

export default Video


// WEBPACK FOOTER //
// ./src/app/modules/Cart/classes/Video.js